export default __webpack_public_path__ + "static/media/no-page2.0ee3e27e.svg";